import { render, staticRenderFns } from "./NegociacaoAlterarResposta.vue?vue&type=template&id=c561d71c&scoped=true&"
import script from "./NegociacaoAlterarResposta.vue?vue&type=script&lang=js&"
export * from "./NegociacaoAlterarResposta.vue?vue&type=script&lang=js&"
import style0 from "./NegociacaoAlterarResposta.vue?vue&type=style&index=0&id=c561d71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561d71c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VTextarea})
